
import Header from "../../header";
import Footer from "../../footer";
import ContactForm from "../../contactcomponents/contactform";
import BannerFooter from "../productpages/bannerForFooter";
import priceandvalueimage from '../../../images/footerLinksImages/featuresimage/priceandvalue.png'
function PriceAndValue() {
    const keywords = [
        { title: "Cost-Effective Solutions", summary: "Explore budget-friendly options that deliver high value without compromising quality." },
        { title: "Value for Money", summary: "Understand how to make the most of your investment by prioritizing quality and performance." },
        { title: "Discounted Packages", summary: "Take advantage of special offers and promotions to maximize your purchasing power." },
        { title: "Affordable Quality Products", summary: "Find high-quality products that meet your needs at a reasonable price." },
        { title: "Price Comparison", summary: "Compare prices across different providers to find the best deals and offers." },
        { title: "Flexible Payment Plans", summary: "Explore flexible payment options that fit your budget and financial situation." },
        { title: "Economical Services", summary: "Get excellent services at prices that are designed to fit various budgets." },
        { title: "Discounted Rates", summary: "Benefit from attractive discounts that help you save money on purchases." },
        { title: "Long-Term Savings", summary: "Learn how to invest in products or services that offer value over time, saving money in the long run." },
        { title: "Quality on a Budget", summary: "Achieve the perfect balance of quality and affordability in the products and services you choose." },
      ];
    return (<>
        <Header />
       
        <BannerFooter
            title="Affordable Pricing & Value"
            text="Our commitment to providing affordable pricing ensures that high-quality services and learning opportunities are accessible to everyone. We offer competitive rates without compromising on the excellence of education and support. By maintaining a balance between cost-effectiveness and value, we provide exceptional learning experiences that maximize the return on investment for our customers. Whether you're looking for professional training or advanced resources, our pricing model is designed to cater to various budgets, ensuring that you receive the best value for your money. We believe that everyone should have the opportunity to invest in their personal and professional growth without breaking the bank."
            imageone={priceandvalueimage}
            imagetwo={priceandvalueimage}
        />
        <div className="container-fluid py-5 bg-light">
  <div className="container p-4 shadow-lg bg-white rounded">
    <h2 className="text-center mb-4">Affordable Pricing & Value</h2>
    <div className="accordion" id="pricingAccordion">
      {keywords.map((item, index) => (
        <div className="accordion-item" key={index}>
          <h2 className="accordion-header" id={`heading-${index}`}>
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target={`#collapse-${index}`}
              aria-expanded="false"
              aria-controls={`collapse-${index}`}
              style={{ transition: "all 0.3s ease" }}
            >
              {item.title}
            </button>
          </h2>
          <div
            id={`collapse-${index}`}
            className="accordion-collapse collapse"
            aria-labelledby={`heading-${index}`}
            data-bs-parent="#pricingAccordion"
          >
            <div className="accordion-body">
              {item.summary}
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
</div>
        <ContactForm />
        <Footer />
    </>)
}

export default PriceAndValue